// extracted by mini-css-extract-plugin
export default {"root":"EventCardPromoted-module__root___nWEsd","withUpsellModal":"EventCardPromoted-module__withUpsellModal___28SD4"};